import { Component, NgZone, OnInit, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap/dropdown/dropdown';
import { Subscription } from 'rxjs';
import { ImpersonationService } from 'src/app/auth/apigee/impersonation.service';
import { LoggerService } from 'src/app/common/logging/logger.service';
import { OfficeSelectorService } from 'src/app/common/officeSelector/officeSelector.service';
import { PaginationParams, getPagination } from 'src/app/common/pagination/pagination.service';
import { CommonService } from 'src/app/common/rest/common.service';
import { CompanyId } from 'src/app/common/rest/enum/global-id.enum';
import { DashboardRecruitmentModel, DashboardRecruitmentResponseModel } from 'src/app/dashboard-recruitment/models/dashboardRecruitment.model';
import { DashboardRecruitmentCfgService, RecruitmentCenterCfg } from 'src/app/dashboard-recruitment/services/dashboard-recruitment-cfg.service';
import { DashboardRecruitmentService } from 'src/app/dashboard-recruitment/services/dashboard-recruitment.service';
import { ColumnSort } from 'src/app/dashboardCommon/components/cardDetails/datatable.component';
import { TableDetailKpiServiceHost } from 'src/app/dashboardCommon/components/kpiServiceHostComponent';
import { CSVService } from 'src/app/util/csv.service';

class columnBuckeyPriority {
  title: string;
  param: string;
  sortable?: boolean = true;
  sortType?: ColumnSort = ColumnSort.None;
  colspan?: string = '1';
  center?: boolean = false;

  constructor(title: string, param: string, sortable = true, colspan = '1', center = false) {
    this.title = title;
    this.param = param;
    this.sortable = sortable;
    this.colspan = colspan;
    this.center = center;
  }
}

@Component({
    selector: 'bucket-priority',
    templateUrl: './bucket-priority.component.html',
    styleUrls: ['./bucket-priority.component.css'],
    standalone: false
})
export class BucketPriorityComponent extends TableDetailKpiServiceHost<DashboardRecruitmentService, DashboardRecruitmentResponseModel> implements OnInit, OnDestroy {

  buckets: DashboardRecruitmentModel[] = [];
  bucketsPagination: DashboardRecruitmentModel[][] = [];
  paginationParams = new PaginationParams(10, 1, 0);
  columnDefinitions: columnBuckeyPriority[] = [];
  columnSort = ColumnSort;

  @ViewChildren("cardMenu") dropdowns: QueryList<NgbDropdown>;

  public getClassName() { return "BucketPriorityComponent"; }

  private configuration: RecruitmentCenterCfg;

  private raasSubscription: Subscription;
  private officeSelectorSubscription: Subscription;

  private paralelItemsParam: string = 'RCFILLERCONTENTMAX';
  private percentMaxFillerContent = 0;

  constructor(zone: NgZone,
    logger: LoggerService,
    private impersonationService: ImpersonationService,
    private officeSelectorService: OfficeSelectorService,
    dashboardRecruitmentService: DashboardRecruitmentService,
    private serviceCfg: DashboardRecruitmentCfgService,
    private commonService: CommonService,
    private csvService: CSVService) {

    super(zone, logger, dashboardRecruitmentService);
    this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
    this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    this.configuration = this.serviceCfg.getCfg();

    this.columnDefinitions = [
      new columnBuckeyPriority('Bucket', '', false, '2', true),
      new columnBuckeyPriority('Necesitas rellenar', 'neededToFill'),
      new columnBuckeyPriority('Candidatos en bucket', 'nCandidates'),
      new columnBuckeyPriority('Históricos', 'historicalWorkersCount'),
      new columnBuckeyPriority('Applicants no leídos', 'cvNotRead'),
      new columnBuckeyPriority('Peticiones pdtes. cubrir', 'pendingOrders'),
      new columnBuckeyPriority('Peticiones cubiertas semana pasada', 'pendingOrdersLastWeek'),
      new columnBuckeyPriority('', '', false)
    ];
  }

  async ngOnInit() {
    await this.getPercentMaxFillerContent();
  }

  /**
   * Gestiona la carga de datos del bucket solicitado
   * @param data Datos del bucket solicitado
   */
  protected processSummaryData(data: DashboardRecruitmentResponseModel) {
    let sortedBuckets = data.buckets
      .filter(x => x.bucketId > 0 && x.fillerContent < this.percentMaxFillerContent)
      .sort((a, b) => b.orderId - a.orderId);

    if (sortedBuckets.length == 0) {
      return null;
    }
    else {
      this.initialData(sortedBuckets);

      return this.buckets;
    }
  }

  /**
   * Inicializacion de la data de  ordenamiento
   * @param sortedBuckets
   */
  initialData(sortedBuckets) {
    this.buckets = sortedBuckets;
    this.bucketsPagination[0] = [];
    this.bucketsPagination = getPagination(this.paginationParams, this.buckets);

    this.buckets.forEach((x) => {
      x.branchName = x.branchName.toString().replace("bucket", "").replace("RTT", "")
    });
  }

  /**
   * Realiza una ordenación de datos
   * @param a Dato a comparar A
   * @param b Dato a comparar B
   * @param sortType Tipo de orden
   * @returns El dato ordenado
   */
  sortWithOrder(a: any, b: any, sortType: ColumnSort): number {
    switch (sortType) {
      case ColumnSort.Asc: {
        try { a = parseFloat(a.toString()); }
        catch { a = 0; }
        try { b = parseFloat(b.toString()); }
        catch { b = 0; }
        return a - b;
      }
      case ColumnSort.Desc: {
        try { a = parseFloat(a.toString()); }
        catch { a = 0; }
        try { b = parseFloat(b.toString()); }
        catch { b = 0; }
        return b - a;
      }
      default: return 0;
    }
  }

  /**
   * Realiza la ordenación de los datos segun la columna clicada
   * @param columnDefinition Información de la columna clicada
   */
  public sortData(columnDefinition: columnBuckeyPriority): void {
    if (columnDefinition.sortable) {
      switch (columnDefinition.sortType) {
        case ColumnSort.Asc: columnDefinition.sortType = ColumnSort.Desc; break;
        case ColumnSort.Desc: columnDefinition.sortType = ColumnSort.None; break;
        case ColumnSort.None: columnDefinition.sortType = ColumnSort.Asc; break;
      }

      this.columnDefinitions.forEach((column) => { if (column != columnDefinition) column.sortType = ColumnSort.None; });

      let sortedBuckets = this.buckets = this.buckets.sort((a, b) => columnDefinition.sortType == ColumnSort.None
        ? this.sortWithOrder(a['orderId'], b['orderId'], ColumnSort.Desc)
        : this.sortWithOrder(a[columnDefinition.param], b[columnDefinition.param], columnDefinition.sortType))

      this.initialData(sortedBuckets);
    }
  }

  /**
   * Gestiona el tiempo de espera de la información
   * @param data Datos del bucket solicitado
   */
  protected extractUpdateTime(data: DashboardRecruitmentResponseModel): Date {
    return data.updateTimestamp;
  }

  /**
   * Gestiona el vínculo de la búsqueda de candidatos
   * @param model Datos del bucket seleccionado
   */
  viewFill(model: DashboardRecruitmentModel): void {
    let url = this.configuration.talentFillEndPointPattern.format(model.branchIdJob,
      model.bucketId.toString(),
      model.branchId);
    window.open(url, "_blank");
  }

  /**
   * Gestiona el vínculo de la búsqueda job postings
   * @param model Datos del bucket seleccionado
   */
  viewHistory(model: DashboardRecruitmentModel): void {
    let url = this.configuration.talentHistoryEndPointPattern.format(model.branchIdJob,
      model.bucketId.toString(),
      model.branchId);
    window.open(url, "_blank");
  }

  /**
   * Gestiona el vínculo de la búsqueda de candidatos
   * @param model Datos del bucket seleccionado
   */
  viewWorker(model: DashboardRecruitmentModel): void {
    let url = this.configuration.talentWorkerEndPointPattern.format(model.branchIdJob);
    window.open(url, "_blank");
  }

  /**
   * Gestiona el componente de paginación
   * @param page Página a mostrar
   */
  pagination(page: number): void {
    if (page !== this.paginationParams.currentPage) {
      this.paginationParams.currentPage = page;
      this.paginationParams.currentIndex = page - 1;
    }
  }

  /**
   * Obtener el porcentaje maximo para el fillerContent
   */
  async getPercentMaxFillerContent() {
    let companyParams = [
      {
        CompanyId: CompanyId.ALL,
        ParamId: this.paralelItemsParam
      }
    ];

    let response = await this.commonService.getCompanyParams(companyParams).toPromise();
    this.percentMaxFillerContent = parseInt(response.find((x) => { return x.ParamId == this.paralelItemsParam }).MinValue);
  }

  /**
   * Cierra las acciones de la grilla que no pertenezcan a
   * la fila seleccionada
   * @param index Indice del registro seleccionado
   */
  clearSelectedActions(index: number) {
    this.dropdowns.forEach((dropdown, currentIndex) => {
      if (currentIndex !== index) {
        dropdown.close();
      }
    });
  }

  /**
   * Metodo que realiza la exportacion de los datos del bucket a CSV
   */
  exportCSVFile() {
    if (this.buckets.length > 0) {
      let items = [];

      // Seteo de Nombres de Headers
      items.push(
        {
          Name: "Bucket",
          NeededToFill: "Necesitas rellenar",
          NCandidates: "Candidatos en bucket",
          HistoricalWorkersCount: "Históricos",
          CvNotRead: "Applicants no leídos",
          PendingOrders: "Peticiones pdtes. cubrir",
          PendingOrdersLastWeek: "Peticiones cubiertas semana pasada"
        });

      // Datos
      this.buckets.forEach((data) => {
        items.push(
          {
            Name: data.name.concat(" - ", data.branchName),
            NeededToFill: data.neededToFill.toString(),
            NCandidates: data.nCandidates.toString(),
            HistoricalWorkersCount: data.historicalWorkersCount.toString(),
            CvNotRead: data.cvNotRead.toString(),
            PendingOrders: data.pendingOrders.toString(),
            PendingOrdersLastWeek: data.pendingOrdersLastWeek.toString(),
          });
      });

      // Creación de CSV
      this.csvService.exportCSVFile(items, 'RecruitmentBucketPriority' + Date.now());
    }
  }

  /**
   * Limpiar componentes
   */
  public ngOnDestroy(): void {
    if (this.raasSubscription) this.raasSubscription.unsubscribe();
    if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
  }

}
